var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHearing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_19",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.4999C11.975 16.4999 11.3408 16.3062 10.8473 15.9187C10.3533 15.5312 9.975 14.9624 9.7125 14.2124C9.5 13.5874 9.29675 13.1499 9.10275 12.8999C8.90925 12.6499 8.4625 12.2499 7.7625 11.6999C6.9875 11.0749 6.375 10.3687 5.925 9.58115C5.475 8.79365 5.25 7.8499 5.25 6.7499C5.25 5.2624 5.753 4.0154 6.759 3.0089C7.7655 2.0029 9.0125 1.4999 10.5 1.4999C11.9875 1.4999 13.2345 2.0029 14.241 3.0089C15.247 4.0154 15.75 5.2624 15.75 6.7499H14.25C14.25 5.6874 13.8905 4.7969 13.1715 4.0784C12.453 3.3594 11.5625 2.9999 10.5 2.9999C9.4375 2.9999 8.547 3.3594 7.8285 4.0784C7.1095 4.7969 6.75 5.6874 6.75 6.7499C6.75 7.5999 6.91875 8.3249 7.25625 8.9249C7.59375 9.5249 8.075 10.0624 8.7 10.5374C9.35 11.0124 9.85625 11.4749 10.2188 11.9249C10.5812 12.3749 10.85 12.8624 11.025 13.3874C11.2 13.9374 11.4095 14.3437 11.6535 14.6062C11.897 14.8687 12.2625 14.9999 12.75 14.9999C13.1625 14.9999 13.5158 14.8532 13.8098 14.5597C14.1033 14.2657 14.25 13.9124 14.25 13.4999H15.75C15.75 14.3249 15.4563 15.0312 14.8688 15.6187C14.2813 16.2062 13.575 16.4999 12.75 16.4999ZM4.65 12.5624C3.9125 11.8124 3.32825 10.9404 2.89725 9.9464C2.46575 8.9529 2.25 7.8874 2.25 6.7499C2.25 5.5999 2.46575 4.5249 2.89725 3.5249C3.32825 2.5249 3.9125 1.6499 4.65 0.899902L5.7375 1.9499C5.1125 2.5749 4.625 3.29665 4.275 4.11515C3.925 4.93415 3.75 5.8124 3.75 6.7499C3.75 7.6749 3.925 8.54365 4.275 9.35615C4.625 10.1687 5.1125 10.8874 5.7375 11.5124L4.65 12.5624ZM10.5 8.6249C9.975 8.6249 9.53125 8.4404 9.16875 8.0714C8.80625 7.7029 8.625 7.2624 8.625 6.7499C8.625 6.2249 8.80625 5.78115 9.16875 5.41865C9.53125 5.05615 9.975 4.8749 10.5 4.8749C11.025 4.8749 11.4687 5.05615 11.8312 5.41865C12.1937 5.78115 12.375 6.2249 12.375 6.7499C12.375 7.2624 12.1937 7.7029 11.8312 8.0714C11.4687 8.4404 11.025 8.6249 10.5 8.6249Z",
    fill: "#1C1B1F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHearing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hearing.679bc4cd10e0e3518556032b7b25de41.svg";